module.exports = __webpack_public_path__ + "img/GE.0a363d73.png";